/*eslint-disable no-unsafe-optional-chaining */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { useTable, useSortBy, usePagination } from 'react-table';
import useDate from '../../../../utils/useDate';
import { useNavigate, Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import './SearchTable.scss';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';
import { t } from 'i18next';
import noDelete from '../../../../img/pricecompare/no-delete.svg';
import noPin from '../../../../img/pricecompare/no-pin.svg';
import pin from '../../../../img/pricecompare/pin.svg';
import APIEndpoints from '../../../../api/APIEndpoints';
import { axiosInstance } from '../../../../../api/axios';
import { useSelector, useDispatch } from 'react-redux';
import { setRecentSearchList } from '../../../../../redux/admin/priceCompareSlice';
import { HttpSuccessCodes } from '../../../../errorhandling/HttpErrorCodes';
import ToastMessage from '../../../common/ToastMessage';
import { Modal } from 'react-bootstrap';
import GenericButton from 'src/Components/GenericButton/GenericButton';

const SearchTable = ({
  columns,
  data,
  loading,
  pageSizeCount,
  labelProp = 'Recent Request List',
  viewAllLinkVisible = false,
  isSearchText = '',
  recordsFilterHandler,
  setCurrentPagePagination,
  setError,
  setNoData,
  setRecordsToDisplay,
  ...otherProps
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [deleteItemID, setDeleteItemID] = useState(null);
  const { formatDate } = useDate();
  const { recentSearchList } = useSelector((state) => state?.priceCompareAdmin);

  //Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    prepareRow,
    page,
    setPageSize,
    pageCount,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      disableSortRemove: true,
      initialState: { pageIndex: 0, pageSize: pageSizeCount },
    },
    useSortBy,
    usePagination,
  );

  const viewAllRequestHandler = () => {
    navigate('/admin/price-compare/all-service-request', {
      state: { data },
    });
  };

  const providerHandler = (providerDataArr) => {
    /*let finalProviderSrt = '';
    if (providerDataArr?.length === 2) {
      finalProviderSrt = providerDataArr?.slice(0, 1)[0];
      finalProviderSrt = finalProviderSrt + ' ' + '+1 other';
    } else if (providerDataArr?.length === 3) {
      finalProviderSrt = providerDataArr?.slice(0, 1)[0];
      finalProviderSrt = finalProviderSrt + ' ' + '+2 other';
    } else {
      if (providerDataArr) finalProviderSrt = providerDataArr[0];
    }
    return finalProviderSrt;*/
    const providerArr =
      providerDataArr &&
      providerDataArr.length > 0 &&
      providerDataArr.map((p) => p.trim());
    return providerArr && providerArr.length > 0 ? providerArr.join(' ; ') : '';
  };
  const reqestDetailsHandler = (value) => {
    const { providers, requestTitle, serviceFor } = value?.props?.value;
    return (
      <div>
        <div className="link-colors">
          <div className="request-title-wrapper">
            <Link
              to={`/admin/price-compare/show-result/${value.props.cell.row.original.id}`}
              state={{ viewAllLinkVisible: viewAllLinkVisible }}
            >
              {requestTitle}
            </Link>
          </div>
          <div className="service-provider-data">
            <span className="service-container">
              {t('member.price_comparison.recent_table.service_for')}{' '}
              {serviceFor}
            </span>
            <span className="provider-container">
              {t('member.price_comparison.recent_table.providers')}{' '}
              {providerHandler(providers)}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = (row) => {
    setDeleteItemID(row?.original?.id);
    setShow(true);
  };

  const deleteRecentRequestApiHandler = async (requestId) => {
    try {
      const URL = APIEndpoints.deleteRecentRequestById() + requestId;
      const response = await axiosInstance.delete(URL);
      if (
        [
          HttpSuccessCodes.HTTP_SUCCESS_CODE_200,
          HttpSuccessCodes.HTTP_SUCCESS_CODE_201,
        ].includes(response.status)
      ) {
        const DATA = [...recentSearchList];
        const filteredItem = DATA?.filter((item) => item?.id !== requestId);
        dispatch(setRecentSearchList([...filteredItem]));
        recordsFilterHandler([...filteredItem], 10, 1);
        setRecordsToDisplay([...filteredItem]);
        if ([...filteredItem].length === 0) {
          setError(true);
          setNoData(true);
        }
        setCurrentPagePagination(1);
        toast.success(
          <ToastMessage
            type="success"
            subTitle="This request has been successfully deleted from your Recent Request list."
          />,
        );
      }
    } catch (error) {
      console.log(error);
      toast.error(
        <ToastMessage
          type="error"
          subTitle="Something went wrong with the request! Failed to delete this search request."
        />,
      );
    }
  };

  const pinUnpinApiHandler = async (id, status) => {
    try {
      const URL = APIEndpoints.getComparedRequestId();
      const response = await axiosInstance.put(URL, {
        id: id,
        pinned: status,
      });
      if (
        [
          HttpSuccessCodes.HTTP_SUCCESS_CODE_200,
          HttpSuccessCodes.HTTP_SUCCESS_CODE_201,
        ].includes(response.status)
      ) {
        const DATA = [...recentSearchList];
        const itemToBeUpdated = DATA?.filter((item) => item?.id === id)[0];
        const temp = { ...itemToBeUpdated };
        temp.pin = status;
        const updateItemIndex = DATA.indexOf(itemToBeUpdated);
        if (updateItemIndex !== -1) DATA[updateItemIndex] = temp;
        dispatch(setRecentSearchList(DATA));
        setCurrentPagePagination(1);
        recordsFilterHandler(DATA, 10, 1);
        console.log('pin/unpin  this search request.');
        toast.success(
          <ToastMessage
            type="success"
            subTitle={`You have ${
              status ? 'pinned' : 'unpinned'
            } this search request.`}
          />,
        );
      }
    } catch (error) {
      console.log(error);
      toast.error(
        <ToastMessage
          type="error"
          subTitle={`Something went wrong with the request! Failed to ${
            status ? 'pin' : 'unpin'
          } this search request.`}
        />,
      );
    }
  };

  const deleteRecordHandler = (requestId) => {
    deleteRecentRequestApiHandler(requestId);
    handleClose();
  };

  const deleteIconHandler = (value, row) => {
    return (
      <div
        className="delete-icon-container removingIconOnResponsive"
        role="button"
        aria-label="click to delete record"
      >
        {value?.props?.value === false && (
          <img
            src={noDelete}
            alt="delete button"
            onClick={() => handleShow(row)}
          />
        )}
      </div>
    );
  };

  const pinUnpinHandler = (pinUnpinCheckerText, data) => {
    if (pinUnpinCheckerText === 'pin') {
      pinUnpinApiHandler(data?.original?.id, true);
    } else {
      pinUnpinApiHandler(data?.original?.id, false);
    }
  };

  const pinIconHandler = (value, row) => {
    return (
      <div
        className={`pin-icon-container removingIconOnResponsive ${
          value?.props?.value && 'pin-show-always'
        }`}
        role="button"
        aria-label={`click to ${
          value?.props?.value ? 'unpin ' : 'pin '
        } record`}
      >
        {value?.props?.value ? (
          <img
            src={pin}
            alt="unpin button"
            onClick={() => pinUnpinHandler('unpin', row)}
          />
        ) : (
          <img
            src={noPin}
            alt="pin button"
            onClick={() => pinUnpinHandler('pin', row)}
          />
        )}
      </div>
    );
  };

  const dateHandler = (value) => {
    return formatDate(value?.original?.date);
  };

  const dataRenderHandler = (index, value, row) => {
    if (index === 0) {
      return reqestDetailsHandler(value);
    } else if (index === 1) {
      return deleteIconHandler(value, row);
    } else if (index === 2) {
      return pinIconHandler(value, row);
    } else if (index === 3) {
      return dateHandler(row);
    }
  };

  useMemo(() => {
    setPageSize(pageSizeCount);
  }, [pageSizeCount]);
  //Render the UI for your table
  return (
    <>
      <div className="recent-search-table-admin">
        <table
          className="table padding-mobile-0"
          {...getTableProps()}
          aria-rowcount={data?.length}
          onBlur={() => setIsLoading(true)}
        >
          <caption className="sr-only">{labelProp}</caption>
          {data?.length > 0 && (
            <thead role="rowgroup">
              {headerGroups.map((headerGroup, index) => (
                <tr
                  key={index}
                  {...headerGroup.getHeaderGroupProps()}
                  role="row"
                >
                  {headerGroup.headers.map((column, key) => (
                    <th
                      key={index}
                      {...column.getHeaderProps(
                        column.getSortByToggleProps({ title: undefined }),
                      )}
                      scope="col"
                      role="columnheader"
                      onKeyPress={(event) => {
                        if (
                          column.sortable !== false &&
                          event.key === 'Enter'
                        ) {
                          column.toggleSortBy();
                        }
                      }}
                      className={
                        column.isSorted
                          ? `${
                              column?.id === 'date' && 'dateContainer'
                            } coloumnIsSorted`
                          : `${
                              column?.id === 'date' && 'dateContainer'
                            } coloumnNotSorted`
                      }
                    >
                      <b>{column.render('Header')}</b>
                      <span
                        className={
                          column.isSorted
                            ? column.isSortedDesc
                              ? 'arrowDown'
                              : 'arrowUp'
                            : `arrowNormal ${
                                column?.id === 'delete' || column?.id === 'pin'
                                  ? 'd-none'
                                  : ''
                              }`
                        }
                        tabIndex={0}
                        aria-label={
                          column.isSorted
                            ? column.isSortedDesc
                              ? ` ${column.Header} sorted descending`
                              : ` ${column.Header} sorted ascending`
                            : ` ${column.Header} sorted none`
                        }
                        aria-live="polite"
                        aria-atomic={isLoading}
                        aria-sort={
                          column.isSorted
                            ? column.isSortedDesc
                              ? 'descending'
                              : 'ascending'
                            : 'none'
                        }
                      ></span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
          )}
          <tbody
            className="data-container"
            {...getTableBodyProps()}
            role="rowgroup"
          >
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <tr key={index} {...row.getRowProps()} scope="row">
                  {row.cells.map((cell, index) => {
                    return (
                      <td
                        key={index}
                        {...cell.getCellProps()}
                        role="cell"
                        //onClick={() => onClick( row )}
                        className={index === 3 ? 'dateContainer' : ''}
                      >
                        <div className="delete-model-container">
                          <Modal
                            show={show}
                            onHide={handleClose}
                            centered
                            className="modal-class"
                          >
                            <Modal.Header closeButton className="px-0">
                              <Modal.Title>
                                {t(
                                  'member.price_comparison.recent_table.delete_model_header',
                                )}
                              </Modal.Title>
                            </Modal.Header>

                            <Modal.Body className="body-class">
                              {t(
                                'member.price_comparison.recent_table.delete_modal_body_content',
                              )}
                            </Modal.Body>

                            <Modal.Footer className="admin bg-white footer-class">
                              <GenericButton
                                className="p-0 m-0"
                                variant="link"
                                onClick={() => handleClose()}
                              >
                                {t('label_cancel')}
                              </GenericButton>

                              <GenericButton
                                variant="primary"
                                onClick={() =>
                                  deleteRecordHandler(deleteItemID)
                                }
                              >
                                {t('label_confirm')}
                              </GenericButton>
                            </Modal.Footer>
                          </Modal>
                        </div>
                        <div className="request-data">
                          {dataRenderHandler(index, cell.render('Cell'), row)}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
          <tfoot role="footer">
            {viewAllLinkVisible && (
              <tr>
                <td className="bg-white" colSpan="4">
                  <span
                    className="view-all"
                    onClick={() => viewAllRequestHandler()}
                  >
                    View All
                  </span>
                </td>
              </tr>
            )}
          </tfoot>
        </table>
        {data?.length === 0 && isSearchText && (
          <div className="document-no-data text-center">
            <CustomClientError
              CustomClasses="p-0 m-0"
              ErrorHeading={t(
                'member.price_comparison.recent_table.not_found_error_heading',
              )}
              ErrorMessage={t(
                'member.price_comparison.recent_table.not_found_error_message',
              )}
            />
          </div>
        )}
      </div>
      {/*<div className="toastify">
        <ToastContainer
          draggable
          pauseOnHover
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          autoClose={5000}
          position="top-center"
          newestOnTop={false}
          hideProgressBar={false}
          className="toastcontainer"
        />
      </div> */}
    </>
  );
};

export default SearchTable;
